import { Permission } from '../../legacy/common/types'
import AccessControl from '../../legacy/components/AccessControl/AccessControl'
import { type AccessControlConfig } from '../../legacy/components/AccessControl/accessControl.utils'

export const AppAdminSectionAccessControl: AccessControlConfig = {
  permissions: AccessControl.oneOf([Permission.AdminPanel, Permission.GlobalAdmin]),
}
